export const constants = {
  USERNAME: 'USER_NAME',
  ROLE: 'ROLE',
  USER_ID: 'USER_ID'
};
